export const baseUrl = "https://ya-praktikum.tech/api/v2"
export const resources = "/resources"
